import IPublicMeetingService from "../../spi/IPublicMeetingService";
import IMeeting, { IMeetingStatus, IMeetingPresenter, IMeetingUserStatus, IMeetingParticipant, IMeetingPresentation, ISlideType, convertToMeeting } from "../../../types/IMeeting";
import FirebaseService from "./FirebaseService";


export default class FirebasePublicMeetingService implements IPublicMeetingService {

  getMeeting(forUserId: string, meetingId: string): Promise<any> {
    throw new Error("Method not implemented.");
  }

  updateMeeting(): Promise<any> {
    throw new Error("Method not implemented.");
  }

  async getMeetingId(sharecode: any): Promise<any> {
    let object = {} as any; 
    try {
      const snapshot =  await FirebaseService.getInstance()
                          .sharecode(sharecode).get();
      object =  snapshot.data();
    } 
    catch (e) {
      console.log(e);
      
      throw e;
    }
    return object;
  }

  async updateMeetingAttribute(refPath: any, attrName: string, attrValue: any) : Promise<any> {
    const updateObj = {} as any;
    updateObj["" + attrName] = attrValue;
    debugger
    try{
        let x = await FirebaseService.getInstance()
                  .database()
                  .ref(refPath)
                  .update(updateObj, function (error: any) {
                    if (error) {
                      console.log("Couldnot join meeting. Failed!");
                      return false;
                    } else {
                      return true;
                      // Data saved successfully!
                    }
                  })
    }catch(e){
        throw e;
    }
    return false;
  }

  async updateSharecodeAttribute(refPath: any, attrName: string, attrValue: any) : Promise<any> {
    const updateObj = {} as any;
    updateObj["" + attrName] = attrValue;
    debugger
    try{
        // let x = await FirebaseService.getInstance()
        //           .sharecode()
        //           .update(updateObj, function (error: any) {
        //             if (error) {
        //               console.log("Couldnot join meeting. Failed!");
        //               return false;
        //             } else {
        //               return true;
        //               // Data saved successfully!
        //             }
        //           })
    }catch(e){
        throw e;
    }
    return false;
  }
}